module.exports = __webpack_public_path__ + "static/aide-front-0a3a32b760096486f6bfefb8e4b5d6f6.mp4";